import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSupabaseTypedClient } from 'hooks/reactQuery';

import { EdgeFunctionName } from 'types/edgeFunctions';
import { TanstackQueryName } from 'types/frontend';

export const useCompleteOnboardingStepMutation = () => {
  const supabase = useSupabaseTypedClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data, error } = await supabase.functions.invoke<boolean>(
        EdgeFunctionName.CompleteOnboardingStep
      );

      if (error) throw error;

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TanstackQueryName.GetCurrentUser] });
    },
  });
};
